// extracted by mini-css-extract-plugin
export var content = "_b1-3";
export var list = "_b1-4";
export var settingsContent = "_b1-7";
export var settingsPanel = "_b1-8";
export var state = "_b1-6";
export var triggerBadge = "_b1-2";
export var triggerButton = "_b1-1";
export var triggerShell = "_b1-0";
export var unreadDot = "_b1-5";